import { html, rune, View } from 'rune-ts';
import klass from './ExhibitionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

export class ExhibitionSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      exhibition_title: html.preventEscape(ET('mps2::landing::popup_store::exhibition_title')),
      exhibition_description: html.preventEscape(ET(`mps2::landing::popup_store::exhibition_description`)),
      exhibition_plan: html.preventEscape(ET('mps2::landing::popup_store::exhibition_plan')),
      exhibition_plan_description: html.preventEscape(
        ET('mps2::landing::popup_store::exhibition_plan_description'),
      ),
      exhibition_produce: html.preventEscape(ET('mps2::landing::popup_store::exhibition_produce')),
      exhibition_produce_description: html.preventEscape(
        ET('mps2::landing::popup_store::exhibition_produce_description'),
      ),
      exhibition_sale: html.preventEscape(ET('mps2::landing::popup_store::exhibition_sale')),
      exhibition_sale_description: html.preventEscape(
        ET('mps2::landing::popup_store::exhibition_sale_description'),
      ),
      exhibition_delivery: html.preventEscape(ET('mps2::landing::popup_store::exhibition_delivery')),
      exhibition_delivery_description: html.preventEscape(
        ET('mps2::landing::popup_store::exhibition_delivery_description'),
      ),
    };
    return html`
      <section class="${klass.exhibition}">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.exhibition_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_medium' })}">
            ${texts.exhibition_description}
          </div>
        </div>
        <div class="${klass.card_list}">
          <div class="${klass.card}">
            <img
              src="${getResizedUrl({
                url: `//s3.marpple.co/files/u_14345/2024/6/original/popupstore-1.png`,
                width: 1920 * 2,
                format: 'webp',
                quality: 85,
              })}"
              alt="팝업스토어 기획"
              class="${klass.card_image}"
            />
            <div class="${klass.title}  ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
              ${texts.exhibition_plan}
            </div>
            <div class="${klass.description}  ${typoPcMo({ is_mobile, pc: '20_medium', mo: '12_medium' })}">
              ${texts.exhibition_plan_description}
            </div>
          </div>
          <div class="${klass.card}">
            <img
              src="${getResizedUrl({
                url: `//s3.marpple.co/files/u_14345/2024/6/original/popupstore-2.png`,
                width: 1920 * 2,
                format: 'webp',
                quality: 85,
              })}"
              alt="기획 상품 제작"
              class="${klass.card_image}"
            />
            <div class="${klass.title}  ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
              ${texts.exhibition_produce}
            </div>
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '12_medium' })}">
              ${texts.exhibition_produce_description}
            </div>
          </div>
          <div class="${klass.card}">
            <img
              src="${getResizedUrl({
                url: `//s3.marpple.co/files/u_14345/2024/6/original/popupstore-3.png`,
                width: 1920 * 2,
                format: 'webp',
                quality: 85,
              })}"
              alt="팝업스토어 판매"
              class="${klass.card_image}"
            />
            <div class="${klass.title}  ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
              ${texts.exhibition_sale}
            </div>
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '12_medium' })}">
              ${texts.exhibition_sale_description}
            </div>
          </div>
          <div class="${klass.card}">
            <img
              src="${getResizedUrl({
                url: `//s3.marpple.co/files/u_14345/2024/6/original/popupstore-4.png`,
                width: 1920 * 2,
                format: 'webp',
                quality: 85,
              })}"
              alt="배송 및 재고 관리"
              class="${klass.card_image}"
            />
            <div class="${klass.title}  ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
              ${texts.exhibition_delivery}
            </div>
            <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '12_medium' })}">
              ${texts.exhibition_delivery_description}
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
